// extracted by mini-css-extract-plugin
export var actions = "_qu-5";
export var assistantBubble = "_qu-3";
export var assistantRow = "_qu-6";
export var bubble = "_qu-0";
export var humanAvatar = "_qu-4";
export var inlineToolCard = "_qu-1";
export var userBubble = "_qu-2";